import React, { useEffect } from 'react';
import './styles/CommunityDetailModal.css';
import { formatFirebaseTimestamp } from '../../utils/datetime';

const CloseIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 6 6 18" /><path d="m6 6 12 12" />
    </svg>
);

const DetailRow = ({ label, value }) => (
    <div className="cd-detail-row">
        <span className="cd-detail-label">{label}</span>
        <span className="cd-detail-value">{value ?? '—'}</span>
    </div>
);

export default function CommunityDetailModal({ community, onClose }) {
    useEffect(() => {
        const handleEsc = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', handleEsc);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', handleEsc);
            document.body.style.overflow = '';
        };
    }, [onClose]);

    if (!community) return null;

    const initials = community.name
        ? community.name.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase()
        : '#';

    return (
        <div className="cd-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
            <div className="cd-modal" role="dialog" aria-modal="true">
                <button className="cd-close" onClick={onClose} aria-label="Close">
                    <CloseIcon />
                </button>

                {/* Header */}
                <div className="cd-header">
                    <div className="cd-avatar">{initials}</div>
                    <div className="cd-header-info">
                        <div className="cd-name">{community.name ?? '—'}</div>
                        <div className="cd-badges">
                            {community.type && (
                                <span className="cd-badge type">{community.type}</span>
                            )}
                        </div>
                    </div>
                </div>

                {/* Body */}
                <div className="cd-body">
                    <div className="cd-details">
                        <DetailRow label="Community ID" value={<span className="cd-mono">{community.id}</span>} />
                        <DetailRow label="Created" value={formatFirebaseTimestamp(community.createdAt)} />
                        <DetailRow label="Created by" value={<span className="cd-mono">{community.createdBy ?? '—'}</span>} />
                        {community.description && (
                            <DetailRow label="Description" value={community.description} />
                        )}
                        {community.memberCount != null && (
                            <DetailRow label="Members" value={community.memberCount} />
                        )}
                        {community.isPrivate != null && (
                            <DetailRow
                                label="Visibility"
                                value={
                                    <span className={`cd-visibility ${community.isPrivate ? 'private' : 'public'}`}>
                                        {community.isPrivate ? 'Private' : 'Public'}
                                    </span>
                                }
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
